import React from "react";
import * as styles from "./Separator.module.scss";
import classNames from "classnames";
import PropTypes from "prop-types";

const Separator = ({ size = 30, className }) => {
	const separatorClassName = classNames({
		[styles["separator"]]: true,
		[`my-${size}`]: !!size,
		[className]: !!className,
	});

	return <div className={separatorClassName}></div>;
};

Separator.propTypes = {
	size: PropTypes.oneOf([0, 6, 12, 18, 24, 30, 36, 60, 120]),
	className: PropTypes.string,
};

export default Separator;
